var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"title":"拆解","confirm-loading":_vm.loading},on:{"ok":_vm.handleOk,"cancel":_vm.onClose}},[_c('a-form-model',{attrs:{"label":"上级工单号"}},[_c('a-input',{attrs:{"allowClear":"","placehoder":"请输入要拆解的单号，多个用逗号隔开"},model:{value:(_vm.billNos),callback:function ($$v) {_vm.billNos=$$v},expression:"billNos"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }